module.exports = __webpack_public_path__ + "images/Chewy-9a479c.png";